export default "__VITE_ASSET__Bv__KnDs__"